import { ComponentChildren, h } from 'preact'
import './style.scss'

function PageWrapper({ children, className = '' }: { children: ComponentChildren; className?: string }) {
  return <div className={`page-wrapper_ta ${className}`}>{children}</div>
}

export default PageWrapper
